/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * Community Tiles Component
 */

import { defineAsyncComponent } from 'vue';

import { type App } from '~/app';

import { type Amenity } from '../../card/llc-community-card/interfaces';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Community Tiles Component');
    app.vueApp.component('community-tiles', defineAsyncComponent(async () => import("./CommunityTiles.vue")));
};

function groupBy(array:any, property:string) {
    // eslint-disable-next-line unicorn/no-array-reduce
    return array.reduce(function (memo:any, x:any) {
        if (!memo[x[property]]) { memo[x[property]] = []; }
        memo[x[property]].push(x);
        return memo;
    }, {});
}

;

export function mapAmenitiesRawValue(rawAmenity:any):Amenity[] {
    const amenities: Amenity[] = [];
    if (rawAmenity && rawAmenity.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const groupedType = groupBy(rawAmenity,'type')//Object.groupBy(rawAmenity, ({ type:any }) => type);
        if (groupedType) {
            for (const item in groupedType) {
                if(item && item !== 'undefined' && item !== 'null') 
                {
                    const amenity: Amenity = {
                        name: item,
                        count: groupedType[item]?.length ?? 0,
                        icon: rawAmenity.filter((x:any) => x.type === item) ? rawAmenity.find((x:any) => x.type === item)?.icon : ''
                    }
                    amenities.push(amenity);
                }
            }
        }
    }
    
    return amenities;
}

